export const ICC_INBOX_MESSAGE_STATUS_TYPES = {
    READ: 'READ',
    UNREAD: 'UNREAD',
};

export const isInboxMessageStatusRead = (status) => status === ICC_INBOX_MESSAGE_STATUS_TYPES.READ;
